__turbopack_context__.v({
  "bg": "BxGvKG_bg",
  "card": "BxGvKG_card",
  "content": "BxGvKG_content",
  "cta": "BxGvKG_cta",
  "ctas": "BxGvKG_ctas",
  "frame": "BxGvKG_frame",
  "heroIn": "BxGvKG_heroIn",
  "lede": "BxGvKG_lede",
  "ledeLong": "BxGvKG_ledeLong",
  "leftScrim": "BxGvKG_leftScrim",
  "title": "BxGvKG_title",
});
